import React from 'react'
import { BetterComponent } from '../../../components/better-component/better-component'
import { BetterSelect } from '../../../components/better-select/better-select'
import { IFilterBuilderProps } from '../interfaces/filter-builder'
import { getClassNames } from '../../../_utils/classnames'
import { AppService } from '../../../services'
import { Container } from 'typescript-ioc/es5'
import { NotificationTestSearchBar } from '../../../components/notification-test-search-bar/notification-test-search-bar'
import { PromptSearchBar } from '../../../components/prompt-search-bar/prompt-search-bar'
import { ReportFilterOperator, VALUELESS_OPERATORS } from '../enums/report-filter-operator'
import './style/test-id.filter-builder.scss'
import clone from 'clone'

interface ITestIdFilterBuilder extends IFilterBuilderProps {
    testEntity: 'notifications' | 'prompts'
}

export class TestIdFilterBuilder extends BetterComponent<ITestIdFilterBuilder, any> {
    protected appService: AppService

    constructor(props: ITestIdFilterBuilder) {
        super(props)

        this.appService = Container.get(AppService)
    }

    public render(): React.ReactNode {
        return (
            <>
                <div className={getClassNames('filter', 'abid-filter')}>
                    <div className={getClassNames('filter-wrapper')}>
                        <div className={getClassNames('filter-display')}>
                            <span className="filter-op">{this.currentOperatorDisplay}</span>
                        </div>
                        <div className={getClassNames('filter-editor')}>
                            <div className="filter-op">
                                <BetterSelect
                                    size="small"
                                    disableSearch={true}
                                    dropdownClassName="filter-op-dropdown"
                                    options={[
                                        { value: ReportFilterOperator.IN, label: 'is' },
                                        { value: ReportFilterOperator.NOT_IN, label: 'is not' },
                                        { value: ReportFilterOperator.IS_NOT_NULL, label: 'exists' },
                                        { value: ReportFilterOperator.IS_NULL, label: 'does not exist' },
                                    ]}
                                    defaultValue={[ReportFilterOperator.IN]}
                                    value={this.currentValue.operator}
                                    onChange={(operator: ReportFilterOperator) => this.handleChange({ operator })}
                                />
                            </div>
                        </div>
                        {!VALUELESS_OPERATORS.includes(this.currentValue.operator) &&
                            this.props.testEntity === 'notifications' && (
                                <div className="filter-val">
                                    <NotificationTestSearchBar
                                        className="notif-test-search"
                                        mode={this.props.mode === 'display' ? 'display' : 'search'}
                                        value={this.currentValueStr}
                                        placeholder="Search ID or Name"
                                        onChange={this.handleTestChange}
                                        getDropdownContainer={this.appService.getAppContainer}
                                        preload={true}
                                    />
                                </div>
                            )}
                        {!VALUELESS_OPERATORS.includes(this.currentValue.operator) && this.props.testEntity === 'prompts' && (
                            <div className="filter-val">
                                <PromptSearchBar
                                    className="prompt-test-search"
                                    mode={this.props.mode === 'display' ? 'display' : 'search'}
                                    value={this.currentValueStr}
                                    placeholder="Search ID or Name"
                                    onChange={this.handleTestChange}
                                    getDropdownContainer={this.appService.getAppContainer}
                                    entityLevel="promptGroup"
                                />
                            </div>
                        )}
                    </div>
                </div>
            </>
        )
    }

    protected get currentValue(): any {
        const propsValue: any = this.props.value || {}
        return clone({
            field: 'TEST_ID',
            operator: propsValue.operator || ReportFilterOperator.IN,
            value: propsValue.value,
        })
    }

    protected get currentOperatorDisplay(): any {
        const labels: Record<string, string> = {
            [ReportFilterOperator.IN]: 'is',
            [ReportFilterOperator.NOT_IN]: 'is not',
            [ReportFilterOperator.IS_NOT_NULL]: 'exists',
            [ReportFilterOperator.IS_NULL]: 'does not exist',
        }
        return labels[this.currentValue.operator] || 'is'
    }

    protected get currentValueStr(): any {
        const value = this.currentValue.value || undefined
        return Array.isArray(value) ? value.join(',') : value
    }

    protected handleTestChange = (testId: number) => {
        this.handleChange({ value: !testId ? undefined : [testId] })
    }

    protected handleChange(config: any): any {
        if (!!config) {
            const nextValue = {
                ...this.props.value,
                ...config,
                field: 'TEST_ID',
            }

            if (VALUELESS_OPERATORS.includes(nextValue.operator)) {
                nextValue.value = undefined
            }

            this.props.onChange(nextValue)
        } else {
            this.props.onChange()
        }
    }
}
